import * as ripsService from '@/services/rips-api.service';

import { CLEAR_EMBED_URL, CLEAR_RIPS_DETAIL, CLEAR_RIPS_DETAIL_BODY, CLEAR_RIPS_RESULT_BODY, EMBED_URL_ERROR, EMBED_URL_LOADING, EMBED_URL_SUCCESS, RIPS_DETAIL_ERROR, RIPS_DETAIL_HEADER, RIPS_DETAIL_LOADING, RIPS_DETAIL_SUCCESS, RIPS_RESULT_ERROR, RIPS_RESULT_LOADING, RIPS_RESULT_SUCCESS } from "./types"
import { camelizeKeys } from 'humps';

const setRipsDetailHeader = ({commit}, payload) => {
    commit(RIPS_DETAIL_HEADER, payload)
}

const clearRipsDetail = ({commit}) => {
    commit(CLEAR_RIPS_DETAIL)
}

const getRIPSHistoryDetail = async ({ commit }, id) => {
    commit(CLEAR_RIPS_DETAIL_BODY)
    commit(RIPS_DETAIL_LOADING, true)
    try {
        const response = await ripsService.getRIPSHistoryDetail(id);
        commit(RIPS_DETAIL_SUCCESS, camelizeKeys(response.data))
        commit(RIPS_DETAIL_LOADING, false)
    } catch (error) {
        commit(RIPS_DETAIL_ERROR, error)
        commit(RIPS_DETAIL_LOADING, false)
    }
};

const getRIPSResultsById = async ({ commit }, id) => {
    commit(CLEAR_RIPS_RESULT_BODY)
    commit(RIPS_RESULT_LOADING, true)
    try {
        const response = await ripsService.getRIPSResultsById(id);
        commit(RIPS_RESULT_SUCCESS, camelizeKeys(response.data))
        commit(RIPS_RESULT_LOADING, false)
    } catch (error) {
        commit(RIPS_RESULT_ERROR, error)
        commit(RIPS_RESULT_LOADING, false)
    }
};

const getEmbedURL = async ({ commit }, user) => {
    commit(EMBED_URL_LOADING, true)
    try {
        const response = await ripsService.getEmbedURL(user);
        commit(EMBED_URL_SUCCESS, response.data)
        commit(EMBED_URL_LOADING, false)
    } catch (error) {
        commit(EMBED_URL_ERROR, error)
        commit(EMBED_URL_LOADING, false)
    }
};

const clearEmbedURL = ({commit}) => {
    commit(CLEAR_EMBED_URL)
}


export default {
    setRipsDetailHeader,
    clearRipsDetail,
    getRIPSHistoryDetail,
    getRIPSResultsById,
    getEmbedURL,
    clearEmbedURL
}